/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import {
  blue,
  brown,
  green,
  orange,
  purple,
  red,
  teal,
  yellow,
  grey,
} from "@mui/material/colors";

import { createMuiTheme, ThemeProvider } from "@mui/material/styles";

import { makeStyles, withStyles } from "@mui/styles";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PAuthenticationWindow from "../../components/pos/PAuthenticationWindow";
import { PrintUtils } from "../../utils/PrintUtils";
import { SaleUtils } from "../../utils/SaleUtils";
import { Store } from "../../utils/Store";
const useStyles = makeStyles({});

const theme = createMuiTheme({
  status: {
    danger: orange[500],
  },
});

const ActionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.85rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
  },
}))(Button);

export default function RestaurantActionPanel(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [customerId, setCustomerId] = useState("");
  const [showAuthScreen, setShowAuthScreen] = useState(false);
  const [enableNote, setEnableNote] = useState(false);

  var biRef = {};
  function onOpenDrawer() {
    PrintUtils.openDrawer(props.terminalBean, props.setAlert, translate);
  }

  useEffect(() => {
    let en = false;
    if (props.saleData) {
      for (let d of props.saleData) {
        if (d[9].info.selected) {
          en = true;
        }
      }
    }
    setEnableNote(en);
  }, [props.saleData]);

  function reprint() {
    PrintUtils.rePrint(
      props.terminalBean,
      props.setAlert,
      translate,
      false,
      props.pdfViewer
    );
  }

  function handleLoginSucessResponse(authToken) {
    if (
      window.JSBridge &&
      typeof window.JSBridge !== "undefined" &&
      window.JSBridge !== null
    ) {
      let baseUrl = window.JSBridge.getBaseURL();
      getPrivileges(baseUrl, authToken);
    } else {
      getPrivileges("", authToken);
    }
  }

  async function getPrivileges(baseUrl, authToken) {
    try {
      const response = await fetch(baseUrl + "/auth/v1/users/myPrivileges", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + authToken,
        },
      });
      if (response.status === 200) {
        const json = await response.json();
        if (props.setPrivileges) {
          props.setPrivileges(json);
          props.setCurrentUser(Store.parseJwt(authToken).sub);
        }
        console.log(json);
      }
    } catch (e) {
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container style={{ height: "100%" }}>
        <Grid item xs={12}>
          <Grid container style={{ height: "100%" }}>
            <Grid item xs={3} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={
                  props.saleType != "R_SALE" ||
                  !props.privileges.return_buttun_allowed
                }
                style={{
                  backgroundColor:
                    props.saleType === "R_SALE"
                      ? props.returnFlag
                        ? orange[500]
                        : blue[500]
                      : grey[500],
                }}
                onClick={() => {
                  props.changeReturnFlag(!props.returnFlag);
                }}
              >
                {translate("RETURN")}
              </ActionButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={!props.privileges.drawer_buttun_allowed}
                style={{
                  backgroundColor: blue[500],
                }}
                onClick={() => {
                  onOpenDrawer();
                }}
              >
                {translate("DRAWER")}
              </ActionButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={!props.privileges.reprint_buttun_allowed}
                style={{
                  backgroundColor: blue[500],
                }}
                onClick={() => {
                  reprint();
                }}
              >
                {translate("REPRINT")}
              </ActionButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                style={{
                  backgroundColor: props.enableKot ? orange[700] : grey[700],
                }}
                onClick={() => {
                  props.setEnableKot(!props.enableKot);
                }}
              >
                {translate("KOT")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!enableNote}
                onClick={() => {
                  let position = SaleUtils.getCurrentRow(props.saleData);
                  props.setValue(props.saleData[position][9].info.saleItemNote);
                  props.setCurrentScreen("value_capture_note");
                }}
                style={{
                  backgroundColor: blue[500],
                }}
              >
                {translate("Note")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!enableNote}
                onClick={() => props.removeItem()}
                style={{
                  backgroundColor: red[600],
                }}
              >
                {translate("REMOVE")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.void_buttun_allowed}
                onClick={() => {
                  if (props.parentSaleBean) {
                    props.updateSaleStatus(props.parentSaleBean.id, "VOID");
                  }
                  props.resetSale(false);
                }}
                style={{
                  backgroundColor: red[600],
                }}
              >
                {translate("VOID")}
              </ActionButton>
            </Grid>
            <Grid
              item
              xs={
                props.currentMenu == "dineIn" || props.currentMenu == "delivery"
                  ? 6
                  : 12
              }
              style={{ padding: 2 }}
            >
              <ActionButton
                style={{ backgroundColor: blue[700] }}
                onClick={() => {
                  props.persistSale(true);
                }}
              >
                {props.workflowStatus === "NEW"
                  ? translate("Create Order")
                  : translate("Update Order")}
              </ActionButton>
            </Grid>
            {(props.currentMenu == "dineIn" ||
              props.currentMenu == "delivery") && (
              <Grid item xs={6} style={{ padding: 2 }}>
                <ActionButton
                  disabled={props.workflowStatus == "NEW"}
                  style={{ backgroundColor: blue[700] }}
                  onClick={() => {
                    props.createBill(true);
                  }}
                >
                  Create bill
                </ActionButton>
              </Grid>
            )}
            {/*<Grid item xs={6} style={{ padding: 2 }}>
              <ActionButton
                style={{ backgroundColor: blue[700] }}
                onClick={() => {
                  props.showPaymentWindow(true);
                }}
              >
                {translate("Print Invoice")}
              </ActionButton>
              </Grid>*/}
            <Grid item xs={12} style={{ padding: 2 }}>
              <ActionButton
                style={{ fontSize: "1rem", backgroundColor: green[700] }}
                onClick={() => {
                  props.showPaymentWindow(true);
                }}
              >
                {translate("Settle")}
              </ActionButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {showAuthScreen && (
        <PAuthenticationWindow
          context={props.context}
          handleLoginSucessResponse={handleLoginSucessResponse}
          showWindow={setShowAuthScreen}
        ></PAuthenticationWindow>
      )}
    </ThemeProvider>
  );
}
